import { BookingFeatureId, DurationId } from 'core/type/Filter.types';
import { SortField } from 'component/page/search/SortAndFilter/Sort/SortCard.types';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';
import { CategoryId } from 'core/type/Category.types';
import { Sort } from 'gql/autogen/Sort';
import { SubcategoryKey, SubcategoryKeyType } from 'core/type/Subcategory.types';

export const DurationKeyToQueryKey: Record<string, string> = {
    [DurationId.UpTo1Hour]: '1',
    [DurationId.Between1And4Hours]: '2',
    [DurationId.Between4And244Hours]: '3',
};

export const DurationQueryToValues: Record<string, DurationId[]> = {
    1: [DurationId.UpTo1Hour],
    2: [DurationId.Between1And4Hours],
    3: [DurationId.Between4And244Hours, DurationId.Between24And724Hours, DurationId.MoreThan72Hours],
};

export const BookingFeatureKeyToQueryKey: Record<string, string> = {
    [BookingFeatureId.FreeCancellation]: '1',
    [BookingFeatureId.InstantConfirmation]: '2',
};

export const BookingFeatureQueryToValues: Record<string, BookingFeatureId[]> = {
    1: [BookingFeatureId.FreeCancellation],
    2: [BookingFeatureId.InstantConfirmation],
};

interface CategoryKeyType {
    queryKey: string;
    apiId: CategoryId;
}

const CategoryKey: CategoryKeyType[] = [
    { queryKey: '1', apiId: CategoryId.TourAndTrip },
    { queryKey: '2', apiId: CategoryId.FoodAndDrinks },
    { queryKey: '3', apiId: CategoryId.Attractions },
    { queryKey: '4', apiId: CategoryId.OutdoorActivities },
    { queryKey: '5', apiId: CategoryId.IndoorActivities },
    { queryKey: '6', apiId: CategoryId.EventExhibitionShow },
    { queryKey: '7', apiId: CategoryId.Transportation },
    { queryKey: '8', apiId: CategoryId.HealthAndWellness },
    { queryKey: '9', apiId: CategoryId.TravelEssentials },
    { queryKey: '10', apiId: CategoryId.ArtDesignCulture },
    { queryKey: '11', apiId: CategoryId.Tours },
    { queryKey: '12', apiId: CategoryId.SimCardsAndWifi },
    { queryKey: '13', apiId: CategoryId.Experiences },
    { queryKey: '14', apiId: CategoryId.Sales },
];

export const CategoryApiIdToQueryKey = CategoryKey.reduce((prev: Record<string, string>, curr: CategoryKeyType) => {
    prev[curr.apiId] = curr.queryKey;
    return prev;
}, {});

export const CategoryQueryKeyToApiId = CategoryKey.reduce((prev: Record<string, string>, curr: CategoryKeyType) => {
    prev[curr.queryKey] = curr.apiId;
    return prev;
}, {});

export const SubcategoryApiIdToQueryKey = SubcategoryKey.reduce((prev: Record<string, string>, curr: SubcategoryKeyType) => {
    prev[curr.apiId] = curr.queryKey;
    return prev;
}, {});

export const SubcategoryQueryKeyToApiId = SubcategoryKey.reduce((prev: Record<string, string>, curr: SubcategoryKeyType) => {
    prev[curr.queryKey] = curr.apiId;
    return prev;
}, {});

export const SortCodeToQuery: Record<SortField, string> = {
    [SortField.PRICE_ASCENDING]: '1',
    [SortField.RATING_DESCENDING]: '2',
    [SortField.DEFAULT_DEFAULT]: '3',
};

export const SortQueryToCode: Record<string, Sort> = {
    1: { code: SortCode.Price, order: SortOrder.Ascending },
    2: { code: SortCode.Rating, order: SortOrder.Descending },
};
